import { trackSelfDescribingEvent } from '@snowplow/browser-tracker'

import { type Entity } from '../entities'

type CtaType =
  | 'button'
  | 'link popup'
  | 'info popup'
  | 'radio'
  | 'list'
  | 'checkbox'
  | 'accordion'

type CtaInteraction = 'click' | 'open' | 'close'

type CtaLocation = 'First' | 'Second' | 'Third' | 'Fourth' | 'Fifth'

/**
 * Schema is defined in Snowplow Console
 * iglu:com.giffgaff/cta_interact/jsonschema/1-0-0
 * @see https://giffgaff.atlassian.net/wiki/spaces/FAAS/pages/4280156161
 */
type DataSchema = {
  type: CtaType
  interaction: CtaInteraction
  name: string
  location?: CtaLocation
  text?: string
  id?: string
}

/**
 * System entity. Please do not edit it.
 * This is copied from Snowplow Console.
 */
const SYSTEM_ENTITY = {
  schema:
    'iglu:com.snowplowanalytics.snowplow/event_specification/jsonschema/1-0-3',
  data: {
    id: '174b48e8-aaa7-4259-8f1c-59405be6a2ca',
    name: 'CTA Interaction event',
    data_product_id: '12802a3b-975f-4fea-9f6f-a61ace48caef',
    data_product_name: 'CTA Interaction',
    data_product_domain: 'All',
  },
}

/**
 * Track CTA interact SelfDescribing event
 *
 * @param eventData cta_interact event data
 * @param context Additional context entities like product.
 */
export const ctaInteract = (eventData: DataSchema, context: Entity[]) => {
  trackSelfDescribingEvent({
    event: {
      schema: 'iglu:com.giffgaff/cta_interact/jsonschema/1-0-0',
      data: eventData,
    },
    context: [...context, SYSTEM_ENTITY],
  })
}
